
export function handleAdminParentQDDeleted(state, payload) {
    const snapshot = payload;

    const parentNodeId = `p${snapshot.id}`;

    const existingParent =
        state.quantitiesById[parentNodeId];

    if (!existingParent) {
        return state;
    }

    const quantitiesById = {
        ...state.quantitiesById,
    };

    const parentNode = {
        ...existingParent,
        isActive: false,
    };


    quantitiesById[parentNodeId] = parentNode;
    console.log('quantitiesById[parentNodeId]:  ', quantitiesById[parentNodeId])
    return {
        ...state,
        quantitiesById,
    };
}